import styled from 'styled-components';

const RoutesTransition = styled.section`
    bottom: 0;
    font-size: calc(${props => props.theme.fonts.baseSize} + 1vmin);
    left: 0;
    height: 100vh;
    overflow: hidden;
    position: absolute;
    right: 0;
    text-align: center;
    top: 0;

    @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
        min-height: ${props => props.theme.gameSelectorWindow.minHeight};
    }
`;

export default RoutesTransition;


// WEBPACK FOOTER //
// ./src/components/organisms/Routes/Routes.styled.js